'use strict';

module Patersons {

    export class TaxReportsListReport extends AbstractReport {
        investorDocs: TaxReportsListEntry[];
    }

    export class TaxReportsListEntry {
        accountId: string;
        name: string;
        type: string;
        uri: string;
    }
    
}